import {
  GUARANTY_GUARANTY_REQUIREMENT,
  GUARANTY_TYPE,
  GUARANTY_DESCRIPTION,
} from 'modules/Inquiry/Form/formFields';
import { fieldParsers } from 'modules/Inquiry/mapInquiryToApi/fieldParsers';
import { InquiryFormMapper } from 'modules/Inquiry/mapInquiryToApi/InquiryFormMapper.model';

const { toInteger } = fieldParsers;

export const mapGuarantyToApi: InquiryFormMapper = (allFields: any) => {
  return {
    'guaranty-Requirement': toInteger(allFields[GUARANTY_GUARANTY_REQUIREMENT]),
    'guaranty-type': allFields[GUARANTY_TYPE],
    'guaranty-description': allFields[GUARANTY_DESCRIPTION],
  };
};
